import districtConfig from '@/config/district';
import { useCurrencyStore } from '@/stores/currency';

export function useApiDistricts() {
  const {
    $api,
    $i18n,
  } = useNuxtApp();
  const { locale } = $i18n;

  const currencyStore = useCurrencyStore();
  const testingStore = useTestingStore();

  const userCurrency = currencyStore.getCurrentCurrency;

  const defaultQuery = { currency: userCurrency?.code };

  const defaultHeaders = { 'Accept-Language': locale?.value };

  const defaultParams = {};

  const BADGETYPES = {
    'breakfast included': { icon: 'breakfast' },
    'free wifi': { icon: 'wi-fi' },
    'sanitisation badge': {
      icon: 'sanitation-badge',
      illustration: 'sanitation',
    },
    'hoscar': {
      icon: 'trophy',
      illustration: 'trophy',
    },
    'experience': {
      icon: 'rocket',
      illustration: 'rocket',
    },
  };

  const BADGETYPES_UNKNOWN = null;
  const getBadgeIcon = (badgeName) => BADGETYPES[badgeName.toLowerCase()] || BADGETYPES_UNKNOWN;

  const updateApiCityProperties = (propertyList) => {
    return propertyList?.map((property) => {
      property.description = property.intro;
      property.rating = property.avgRating;
      property.numReviews = property.numberReviews;
      property.distance = property.cityCenterDistance;
      if (property.badges && Array.isArray(property.badges)) {
        property.badges = property.badges.map((badge) => {
          const badgeGraphics = getBadgeIcon(badge.badgeName);
          badge.name = badge.badgeName;
          badge.icon = badgeGraphics.icon;
          badge.illustration = badgeGraphics.illustration;
          badge.showLabel = badge.displayMessage;
          return badge;
        });
      }
      property.minDormPrice = property.sharedMinPrice;
      property.minPrivatePrice = property.privateMinPrice;
      property.urlPath = `hosteldetails.php/${property.urlFriendlyName}/${property.urlFriendlyCity}/${property.id}`;
      property.imgSizes = property.imageSizes?.propertyList;
      property.latitude = property.geoCoordinates?.latitude || null;
      property.longitude = property.geoCoordinates?.longitude || null;
      return property;
    });
  };

  // @TODO: https://hostelworld.atlassian.net/browse/COD-5 -> API Source needs to change when apigee work in on SPAPI
  const getDistrictByCityNameAndCountryName = async (
    propertyType,
    countryName,
    cityName,
    districtName,
    pageNum = 1,
    limiter = districtConfig.maxNumberOfPropertiesPerPage,
    isFeatured = 0,
    filters = null,
  ) => {
    const defaultPaginationValue = 1;
    const page = Number.parseInt(pageNum) || defaultPaginationValue;
    const featured = Number.parseInt(isFeatured) || 0;
    const limit = Number.parseInt(limiter) || 30;

    const experimentNewSortOrder = testingStore.hasEnabledFeature('web_newSortOrder');
    const experimentNewSortOrderParticipating = testingStore.hasEnabledFeature('web_newSortOrderIsUserParticipating');
    const bucketNewSortOrder = experimentNewSortOrder ? 'variation' : 'control';

    const internalQuery = {
      limit,
      page,
      featured,
      filters,
      ...defaultQuery,
      origin: 'spapi',
      v: experimentNewSortOrderParticipating ? bucketNewSortOrder : 'holdout',
      priorityPropertyType: propertyType,
    };

    const callKeySpapi = `getDistrictByCityNameAndCountryName${locale?.value}${propertyType}${countryName}${cityName}${districtName}${page}${featured}${limit}${filters}${userCurrency?.code}`;
    const endpointSpapi = `district/${propertyType}/${countryName}/${cityName}/${districtName}/`;
    const resultSpapi = ref(
      await $api.apigee(callKeySpapi, endpointSpapi, defaultHeaders, internalQuery, defaultParams),
    );
    const spapiData = resultSpapi?.value?.data || {};

    if (spapiData?.properties?.length) {
      spapiData.properties = updateApiCityProperties(spapiData?.properties);
    }

    return spapiData || null;
  };

  return { getDistrictByCityNameAndCountryName };
}
